import { PlanForm } from '@/components/billing';
import { useCompanyContext } from '@/components/company-shell';

/**
 * Page `/company/:companyId/plan` — "Contratar plan" tab. Reads the
 * shell context and renders the `PlanForm` for the loaded company.
 */
export const PlanPage = () => {
  const { company, refetch } = useCompanyContext();

  return <PlanForm company={company} refetch={refetch} />;
};
